/** 组织管理页流式返回的单条 JSONL 数据结构。 */
export interface OrganizationStreamItem {
  type: string;
  category: string;
  name: string;
  content: string;
  processName?: string;
}

/**
 * 将不完整的 JSONL 数据块拆分并解析为 JSON 对象数组。
 *
 * 兼容：
 * - 网络分片导致的半包
 * - 同一行多个 JSON 对象粘连，如 `}{`
 * - 最后一行没有换行结尾
 */
export function parseOrganizationStreamChunk(
  dataStr: string,
  cache: { current: string }
): OrganizationStreamItem[] {
  cache.current += dataStr;

  const tryParse = (str: string): OrganizationStreamItem | null => {
    try {
      return JSON.parse(str) as OrganizationStreamItem;
    } catch {
      return null;
    }
  };

  const results: OrganizationStreamItem[] = [];
  const lines = cache.current.split('\n');
  cache.current = lines.pop() || '';

  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) continue;

    if (trimmed.includes('}{')) {
      const parts = trimmed.split('}{');
      for (let i = 0; i < parts.length; i++) {
        let part = parts[i];
        if (i === 0) {
          part = `${part}}`;
        } else if (i === parts.length - 1) {
          part = `{${part}`;
        } else {
          part = `{${part}}`;
        }
        const parsed = tryParse(part);
        if (parsed) results.push(parsed);
      }
      continue;
    }

    const parsed = tryParse(trimmed);
    if (parsed) results.push(parsed);
  }

  if (cache.current.trim()) {
    const parsed = tryParse(cache.current.trim());
    if (parsed) {
      results.push(parsed);
      cache.current = '';
    }
  }

  return results;
}
